import {
  TKeystoneCharacterRankingsClientState,
  TKeystoneRunRankingsClientState,
  TKeystoneTeamRankingsClientState,
  TKeystoneWarbandRankingsClientState
} from '../libs/store';

// Action Types
export const SET_KEYSTONE_RUN_DETAILS = 'SET_KEYSTONE_RUN_DETAILS';
export const SET_KEYSTONE_RUN_SELECTED_VIDEO = 'SET_KEYSTONE_RUN_SELECTED_VIDEO';
export const SET_KEYSTONE_RUN_FORCE_REFRESH = 'SET_KEYSTONE_RUN_FORCE_REFRESH';
export const SET_KEYSTONE_RUN_RANKINGS = 'SET_KEYSTONE_RUN_RANKINGS';
export const SHOW_KEYSTONE_LOADING_SPINNER = 'SHOW_KEYSTONE_LOADING_SPINNER';
export const SHOW_INSTANCED_KEYSTONE_LOADING_SPINNER = 'SHOW_INSTANCED_KEYSTONE_LOADING_SPINNER';
export const SET_KEYSTONE_RUN_LOADING = 'SET_KEYSTONE_RUN_LOADING';
export const SET_KEYSTONE_CHARACTER_RANKINGS = 'SET_KEYSTONE_CHARACTER_RANKINGS';
export const SET_KEYSTONE_WARBAND_RANKINGS = 'SET_KEYSTONE_WARBAND_RANKINGS';
export const REFRESH_KEYSTONE_RANKINGS = 'REFRESH_KEYSTONE_RANKINGS';
export const SET_KEYSTONE_RANKINGS_ERROR = 'SET_KEYSTONE_RANKINGS_ERROR';
export const SET_KEYSTONE_CHARACTER_RANKINGS_ERROR = 'SET_KEYSTONE_CHARACTER_RANKINGS_ERROR';
export const SET_KEYSTONE_WARBAND_RANKINGS_ERROR = 'SET_KEYSTONE_WARBAND_RANKINGS_ERROR';
export const SET_KEYSTONE_TEAM_RANKINGS = 'SET_KEYSTONE_TEAM_RANKINGS';
export const CLEAR_KEYSTONE_TEAMS = 'CLEAR_KEYSTONE_TEAMS';
export const SET_KEYSTONE_RUN_AGGREGATES = 'SET_KEYSTONE_RUN_AGGREGATES';
export const SET_KEYSTONE_RUN_AGGREGATES_FILTER = 'SET_KEYSTONE_RUN_AGGREGATES_FILTER';
export const SET_KEYSTONE_RUN_AGGREGATES_LOADING = 'SET_KEYSTONE_RUN_AGGREGATES_LOADING';
export const SET_KEYSTONE_DUNGEON_STATS = 'SET_KEYSTONE_DUNGEON_STATS';
export const SET_KEYSTONE_DUNGEON_STATS_LOADING = 'SET_KEYSTONE_DUNGEON_STATS_LOADING';
export const SET_KEYSTONE_DUNGEON_RUNS = 'SET_KEYSTONE_DUNGEON_RUNS';
export const SET_KEYSTONE_DUNGEON_RUNS_LOADING = 'SET_KEYSTONE_DUNGEON_RUNS_LOADING';
export const TOGGLE_OPEN_RECENT_RUN = 'TOGGLE_OPEN_RECENT_RUN';
export const TOGGLE_OPEN_MYTHIC_PLUS_RUN = 'TOGGLE_OPEN_MYTHIC_PLUS_RUN';
export const TOGGLE_KEYSTONE_EVENT_BREAKDOWN = 'TOGGLE_KEYSTONE_EVENT_BREAKDOWN';
export const SET_KEYSTONE_RUN_ROUTE_SHOWING = 'TOGGLE_KEYSTONE_RUN_ROUTE';

// Action Creator
const KeystoneActionCreator = {
  toggleOpenRun(runId: number) {
    return {
      type: TOGGLE_OPEN_MYTHIC_PLUS_RUN,
      payload: runId
    };
  },
  toggleOpenRecentRun(runId: number) {
    return {
      type: TOGGLE_OPEN_RECENT_RUN,
      payload: runId
    };
  },
  setKeystoneRunDetails(keystoneRunId: string, details: any) {
    return {
      type: SET_KEYSTONE_RUN_DETAILS,
      payload: {
        keystoneRunId,
        details
      }
    };
  },
  setKeystoneRunVideo(keystoneRunId: string, video: any) {
    return {
      type: SET_KEYSTONE_RUN_SELECTED_VIDEO,
      payload: {
        keystoneRunId,
        video
      }
    };
  },
  setKeystoneRunForceRefresh(keystoneRunId: string) {
    return {
      type: SET_KEYSTONE_RUN_FORCE_REFRESH,
      payload: {
        keystoneRunId
      }
    };
  },
  setKeystoneRunLoading(keystoneRunId: string, loading: boolean) {
    return {
      type: SET_KEYSTONE_RUN_LOADING,
      payload: {
        keystoneRunId,
        loading
      }
    };
  },
  setKeystoneDungeonRuns(key: string, details: any) {
    return {
      type: SET_KEYSTONE_DUNGEON_RUNS,
      payload: {
        ...details,
        key
      }
    };
  },
  setKeystoneDungeonRunsLoading(key: string, loading: boolean) {
    return {
      type: SET_KEYSTONE_DUNGEON_RUNS_LOADING,
      payload: {
        key,
        loading
      }
    };
  },
  setKeystoneRankings(instanceId: string, rankings: TKeystoneRunRankingsClientState) {
    return {
      type: SET_KEYSTONE_RUN_RANKINGS,
      payload: {
        instanceId,
        data: rankings
      }
    };
  },
  setKeystoneCharacterRankings(rankings: TKeystoneCharacterRankingsClientState, instanceId: string = 'default') {
    return {
      type: SET_KEYSTONE_CHARACTER_RANKINGS,
      payload: {
        data: rankings,
        instanceId
      }
    };
  },
  setKeystoneWarbandRankings(rankings: TKeystoneWarbandRankingsClientState, instanceId: string = 'default') {
    return {
      type: SET_KEYSTONE_WARBAND_RANKINGS,
      payload: {
        data: rankings,
        instanceId
      }
    };
  },
  setKeystoneRankingsError(instanceId: string, error: any) {
    return {
      type: SET_KEYSTONE_RANKINGS_ERROR,
      payload: {
        error,
        instanceId
      }
    };
  },
  refreshKeystoneRankings(instanceId: string) {
    return {
      type: REFRESH_KEYSTONE_RANKINGS,
      payload: {
        instanceId
      }
    };
  },
  setKeystoneCharacterRankingsError(instanceId: string, error: any) {
    return {
      type: SET_KEYSTONE_CHARACTER_RANKINGS_ERROR,
      payload: {
        error,
        instanceId
      }
    };
  },
  setKeystoneWarbandRankingsError(instanceId: string, error: any) {
    return {
      type: SET_KEYSTONE_WARBAND_RANKINGS_ERROR,
      payload: {
        error,
        instanceId
      }
    };
  },
  setKeystoneTeamRankings(rankings: TKeystoneTeamRankingsClientState) {
    return {
      type: SET_KEYSTONE_TEAM_RANKINGS,
      payload: rankings
    };
  },
  clearKeystoneTeams() {
    return {
      type: CLEAR_KEYSTONE_TEAMS,
      payload: null
    };
  },
  showLoadingSpinner(instanceId: string, show: boolean) {
    return {
      type: SHOW_KEYSTONE_LOADING_SPINNER,
      payload: {
        instanceId,
        show
      }
    };
  },
  showInstancedLoadingSpinner(instanceId: string, show: boolean) {
    return {
      instanceId,
      type: SHOW_INSTANCED_KEYSTONE_LOADING_SPINNER,
      payload: show
    };
  },
  setKeystoneRunAggregatesLoading(instanceId: string, show: boolean) {
    return {
      instanceId,
      type: SET_KEYSTONE_RUN_AGGREGATES_LOADING,
      payload: show
    };
  },
  setKeystoneRunAggregates(instanceId: string, aggregates: any) {
    return {
      instanceId,
      type: SET_KEYSTONE_RUN_AGGREGATES,
      payload: aggregates
    };
  },
  setKeystoneRunAggregatesFilter(instanceId: string, filters: any) {
    return {
      instanceId,
      type: SET_KEYSTONE_RUN_AGGREGATES_FILTER,
      payload: filters
    };
  },
  setKeystoneDungeonStatsLoading(instanceId: string, show: boolean) {
    return {
      instanceId,
      type: SET_KEYSTONE_DUNGEON_STATS_LOADING,
      payload: show
    };
  },
  setKeystoneDungeonStats(instanceId: string, stats: any) {
    return {
      instanceId,
      type: SET_KEYSTONE_DUNGEON_STATS,
      payload: stats
    };
  },
  toggleKeystoneEventBreakdown(encounterId: number) {
    return {
      type: TOGGLE_KEYSTONE_EVENT_BREAKDOWN,
      payload: encounterId
    };
  },
  setKeystoneRunRouteShowing(keystoneRunId: number, show: boolean) {
    return {
      type: SET_KEYSTONE_RUN_ROUTE_SHOWING,
      payload: { keystoneRunId, show }
    };
  }
};

export default KeystoneActionCreator;
